import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { isVisible } from '../utils/general/enterKey';

const modalRoot: any = document.getElementById('modal-root');
let focusable: any = null;
let firstFocusable: any = null;
let lastFocusable: any = null;

interface IModalPopupProps {
    source?: any;
    classList?: string;
}

class ModalPopup extends PureComponent<IModalPopupProps, any> {
    public el: any;

    constructor(props: IModalPopupProps) {
        super(props);
        this.el = document.createElement('div');
        // The <div> is a necessary container for our content, but it should not affect our layout. Only works in some browsers, but generally doesn't matter since this is at the end anyway. Feel free to delete this line.
        this.el.style.display = 'flex';
        this.el.classList.add("modal-popup-class");
        this.el.classList.add(this.props.classList);
        this.handleClick = this.handleClick.bind(this);
    }

    public componentDidMount() {
        if (!modalRoot) return;
        modalRoot.appendChild(this.el);
        modalRoot.style.zIndex = 1040;
        modalRoot.style.display = 'flex';
        setTimeout(() => {
           this.setFocusableElements();
        }, 1000);
        modalRoot.addEventListener('keydown', this.handleKeyDown);
        modalRoot.addEventListener('click', this.handleClick);
    }

    public handleClick(e: any) {
      if (e.target.id === 'financials-price-chart') {
        setTimeout(() => {
          $('.highcharts-navigator').attr('tabindex', '0');
          $('.highcharts-navigator').attr('aria-label', 'Price Chart Slider');
          $('.highcharts-navigator .highcharts-navigator-handle.highcharts-navigator-handle-right').attr('tabindex', '0');
          $('.highcharts-navigator .highcharts-navigator-handle.highcharts-navigator-handle-right').attr('aria-label', 'Price Chart Navigator Handle Right');
          $('.highcharts-navigator .highcharts-navigator-handle.highcharts-navigator-handle-left').attr('tabindex', '0');
          $('.highcharts-navigator .highcharts-navigator-handle.highcharts-navigator-handle-left').attr('aria-label', 'Price Chart Navigator Handle Left');
        }, 1000);
      }
    }

    public componentWillUnmount() {
        modalRoot.style.zIndex = -1;
        modalRoot.style.display = 'none';
        modalRoot.removeChild(this.el);
        modalRoot.removeEventListener('keydown', this.handleKeyDown);
    }

    public setFocusableElements() {
        const candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not([tabindex="-1"])', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
        const candidateSelector = candidateSelectors.join(',');
        focusable = modalRoot.querySelectorAll(candidateSelector);
        const focusableElements = [];
        for (let i = 0; i < focusable.length; i++) {
          const node = focusable[i];
          const visible = isVisible(node);
          if (visible === true) {
            focusableElements.push(node);
          }
        }
        focusable = focusableElements;
        firstFocusable = focusable[0];
        lastFocusable = focusable[focusable.length - 1];

        if (firstFocusable) {
          firstFocusable.focus();
        }
    }

    public handleKeyDown(e: any) {
      let cancel = false;
      if (e.ctrlKey || e.metaKey || e.altKey) {
          return;
      }
      switch (e.which) {
          case 27: // ESC
            $('#modalClose').click();
            cancel = true;
            break;
          case 9: // TAB
            if (e.shiftKey) {
              if (document.activeElement === firstFocusable) {
                lastFocusable.focus();
                cancel = true;
              }
            } else {
              // console.log(document.activeElement);
              if (document.activeElement === lastFocusable) {
                firstFocusable.focus();
                cancel = true;
              }
            }
            break;
      }
      if (cancel) {
          e.preventDefault();
      }
    }

    public render() {
        focusable = focusable && focusable.length === 0 ? this.setFocusableElements() : focusable;
        if (window.location.search.indexOf('popup=true') >= 0) {
            return null;
        }
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        );
    }
}

export default ModalPopup;
